import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hook } from '@g4/automation-hooks';

import { HOMEPAGE_HERO_IMAGE } from '../../../automationHooks.json';

const FullWidth = styled.div`
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

const Image = styled.div`
  position: relative;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(transparent 55%, white 80%);
  }
`;

const HeroImage = ({ image }) => {
  return (
    <FullWidth>
      {image && <Image image={image} {...hook(HOMEPAGE_HERO_IMAGE.hook)} />}
    </FullWidth>
  );
};

HeroImage.propTypes = {
  image: PropTypes.string,
};

export default HeroImage;
